import { useCallback, useEffect } from 'react';
import { ProfileApi } from 'api/profileAPI';
import { IProfileInfo } from 'pages/profile/models';

export const useFetchProfileDetails = (
  setProfileDetails: React.Dispatch<React.SetStateAction<IProfileInfo | null>>
) => {
  const fetchProfileDetails = useCallback(async () => {
    const result = await ProfileApi.getProfileDetails();
    if (result.data) {
      const data = result.data;
      setProfileDetails(data);
    }

    if (result.error) {
      const error = result.error.message;
    }
  }, []);

  useEffect(() => {
    fetchProfileDetails();
  }, []);
};

export default useFetchProfileDetails;
